import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";
import './index.css'
import {useEffect, useState} from "react";
import associateServices from "../../services";
import Loading from "../../components/loading";
import TicketsList from "./list";
import NoData from "../../components/no-data";
import Big from "big.js";

const Tickets = () => {

    const {t} = useTranslation()
    const [raffle, setRaffle] = useState({})
    const [loading, setLoading] = useState(true)

    const {key} = useParams()

    useEffect(() => {
        setLoading(true)
        associateServices.getRaffleTickets(key).then(res => {
            setRaffle(res?.data || {})
            setLoading(false)
        })
    }, [key])

    return (
        <div className="section section--first">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {
                            raffle?.name && !loading ? <h1 className="section__title section__title--head">
                                {
                                    `${raffle?.name}`
                                    // (${Big(raffle?.tickets?.length || 0).toFixed(2)})
                                }
                            </h1> : ''
                        }

                    </div>
                    <div className="col-12">
                        <div className="content">
                            <div className="dropdown content__dropdown">
                                <button
                                    className="dropdown-toggle content__dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    {t('tickets.title')}
                                </button>
                                <ul
                                    className="dropdown-menu content__dropdown-menu"
                                    aria-labelledby="dropdownMenuButton">

                                    <li>
                                        <button
                                            className="dropdown-item content__dropdown-item"
                                            type="button">
                                            {t(`tickets.title`)}
                                        </button>
                                    </li>

                                </ul>
                            </div>


                            <div className="content__menu">
                                <ul
                                    className="nav nav-tabs content__nav"
                                    id="content__nav"
                                    role="tablist"
                                >
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={'active'}
                                            type="button">
                                            -{t(`tickets.title`)}

                                        </button>
                                    </li>

                                </ul>
                            </div>


                            <div className="content__main content__main--grid">
                                <div className="tab-content">
                                    {
                                        loading ? <Loading/> :
                                            raffle?.key ?
                                                <TicketsList raffle={raffle}/>
                                                : <NoData/>
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}


export default Tickets
